"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconLabContainer = function IconLabContainer(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M30 5H18a3 3 0 1 0 0 6h12a3 3 0 1 0 0-6M18 7h12a1 1 0 1 1 0 2H18a1 1 0 1 1 0-2m2 10v-5h-2v9.775L8.08 38.49l-.1.19A3.002 3.002 0 0 0 10.653 43H37.34l.2-.008a3 3 0 0 0 2.39-1.5l.1-.188a3 3 0 0 0-.104-2.804L30 21.777V12h-2v5h-1.268a2 2 0 0 0-3.464 0zm0 1v4.05c0 .135-.027.268-.08.39l-.06.12L9.806 39.5a1 1 0 0 0 .738 1.492l.116.008h26.674a1 1 0 0 0 .922-1.374l-.056-.116-10.06-16.95a1 1 0 0 1-.131-.376L28 22.05V18h-1a2 2 0 1 1-4 0zm4 0a1 1 0 1 0 2 0zm-6 15a3 3 0 1 1 6 0 3 3 0 0 1-6 0m5 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0m4-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2",
    clipRule: "evenodd"
  })));
};

export { IconLabContainer, IconLabContainer as default };
